import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";
const DEFAULT_EXCLUDE_HIDDEN_DEVICES = true;

export function Refresh(accessToken, buildingId) {
  return {
    type: Pre.AREA + Actions.REFRESH,
    accessToken,
    payload: { buildingId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function GetAll(accessToken, buildingId) {
  return {
    type: Pre.AREA + Actions.ALL,
    accessToken,
    payload: { buildingId },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function GetAllAreaTypes(accessToken) {
  return {
    type: Pre.AREA + Actions.TYPE_ALL,
    accessToken,
    payload: {},
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function ClearAll() {
  return {
    type: Pre.AREA + Actions.CLEAR,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function Add(model, accessToken) {
  const act = {
    type: Pre.AREA + Actions.ADD,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}

export function Remove(
  areaId = 0,
  areaUId = null,
  devicesReplacementAreaId,
  devicesReplacementAreaUId,
  subAreasReplacementAreaId,
  subAreasReplacementAreaUId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    devicesReplacementAreaId,
    devicesReplacementAreaUId,
    subAreasReplacementAreaId,
    subAreasReplacementAreaUId,
  };
  return {
    type: Pre.AREA + Actions.REMOVE,
    payload,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function Update(model, accessToken) {
  return {
    type: Pre.AREA + Actions.UPDATE,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
}

export function copyDevicesTo(
  devices,
  devicesUId,
  areas,
  areasUId,
  oldAreaId = 0,
  oldAreaUId = null,
  accessToken
) {
  var payload = {
    oldAreaId,
    oldAreaUId,
    areas,
    areasUId,
    devices,
    devicesUId,
  };
  return {
    type: Pre.AREA + Actions.COPY_DEVICES_TO_AREAS,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function moveDevicesTo(
  devices,
  devicesUId,
  areas,
  areasUId,
  oldAreaId = 0,
  oldAreaUId = null,
  accessToken
) {
  var payload = {
    oldAreaId,
    oldAreaUId,
    areas,
    areasUId,
    devices,
    devicesUId,
  };
  return {
    type: Pre.AREA + Actions.MOVE_DEVICES_TO_AREAS,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function transportResult(succeeded) {
  return {
    type: Pre.AREA + Actions.TRANSPORT_RESULT,
    payload: {
      succeeded,
    },
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function resetTransportResult() {
  return {
    type: Pre.AREA + Actions.RESET_TRANSPORT_RESULT,
    payload: {},
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function unlinkDevices(
  areaId = 0,
  areaUId = null,
  devices,
  devicesUId,
  accessToken
) {
  var payload = {
    areaId,
    areaUId,
    devices,
    devicesUId,
  };
  return {
    type: Pre.AREA + Actions.UNLINK_DEVICE,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function addNewNodeToAreaLocally(deviceId, areaId) {
  var payload = {
    devices: [],
    uDevices: [],
    areas: [],
    uAreas: [],
  };
  if (typeof areaId === "string" || typeof deviceId === "string") {
    payload.uDevices = [deviceId];
    payload.uAreas = [areaId];
  } else if (typeof areaId === "number" || typeof areaId === "number") {
    payload.devices = [deviceId];
    payload.areas = [areaId];
  }
  return {
    type: Pre.AREA + Actions.COPY_DEVICES_TO_AREAS,
    payload,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function resolveImageSource(areaId, imgSource, serverUrl, accessToken) {
  let imgSourceResolver = require("../../assets/images/noimage.png");
  if (!serverUrl) {
    // return noImage
    return imgSourceResolver;
  }
  if (imgSource) {
    if (imgSource.indexOf("file:///") == 0) {
      imgSourceResolver = {
        uri: imgSource,
      };
    } else {
      imgSourceResolver = {
        uri:
          serverUrl +
          (imgSource.indexOf("/Media/Area/") == 0
            ? imgSource
            : `/Media/Area/${areaId}?t=${Math.random()}`),
        headers: {
          //   Authorization: "Bearer xyz",
        },
        cache: "default",
        //model.imageSource,
      };

      if (accessToken) {
        imgSourceResolver.headers.Authorization = `Bearer ${accessToken}`;
      }
      // normalizing url
      imgSourceResolver.uri = imgSourceResolver.uri.replace(
        "//Media/",
        "/Media/"
      );
    }
  }
  return imgSourceResolver;
}

export function changeLights(
  areaId = 0,
  areaUId = null,
  value = true,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  return {
    type: Pre.AREA + (value ? Actions.TURN_ON_LIGHTS : Actions.TURN_OFF_LIGHTS),
    accessToken,
    payload: {
      areaId,
      areaUId,
      excludeHiddenDevices,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function changeOutlets(
  areaId = 0,
  areaUId = null,
  value = true,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  var payload = {
    areaId,
    areaUId,
    excludeHiddenDevices,
  };

  return {
    type:
      Pre.AREA + (value ? Actions.TURN_ON_OUTLETS : Actions.TURN_OFF_OUTLETS),
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function changeSirens(
  areaId = 0,
  areaUId = null,
  value = true,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  return {
    type: Pre.AREA + (value ? Actions.TURN_ON_SIRENS : Actions.TURN_OFF_SIRENS),
    accessToken,
    payload: {
      areaId,
      areaUId,
      excludeHiddenDevices,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function changePowerSwitches(
  areaId = 0,
  areaUId = 0,
  value = true,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  var payload = {
    areaId,
    areaUId,
    excludeHiddenDevices,
  };
  return {
    type:
      Pre.AREA +
      (value
        ? Actions.TURN_ON_POWER_SWITCHES
        : Actions.TURN_OFF_POWER_SWITCHES),
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function changeWateringSwitches(
  areaId = 0,
  areaUId = null,
  value = true,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  var payload = {
    areaId,
    areaUId,
    excludeHiddenDevices,
  };

  return {
    type:
      Pre.AREA +
      (value
        ? Actions.TURN_ON_WATERING_SWITCHES
        : Actions.TURN_OFF_WATERING_SWITCHES),
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}
export function openCurtains(
  areaId = 0,
  areaUId = null,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  var payload = {
    areaId,
    areaUId,
    excludeHiddenDevices,
  };

  return {
    type: Pre.AREA + Actions.CURTAIN_OPEN,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function closeCurtains(
  areaId = 0,
  areaUId = null,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  var payload = {
    areaId,
    areaUId,
    excludeHiddenDevices,
  };

  return {
    type: Pre.AREA + Actions.CURTAIN_CLOSE,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function changeHVACs(
  areaId = 0,
  areaUId = null,
  value = true,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  return {
    type:
      Pre.AREA +
      (value
        ? Actions.TURN_ON_AIR_CONDITIONERS
        : Actions.TURN_OFF_AIR_CONDITIONERS),
    accessToken,
    payload: {
      areaId,
      areaUId,
      excludeHiddenDevices,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function arm(
  areaId = 0,
  areaUId = null,
  accessToken,
  shouldTurnOffLights,
  shouldTurnOffAirConditioners,
  shouldCheckDoorWindowsClosed,
  shouldCloseCurtains,
  shouldNotifyBreach,
  shouldSmsBreach,
  shouldRunScenarios,
  shouldTurnOnSirens,
  sirensDuration
) {
  return {
    type: Pre.AREA + Actions.ARM,
    accessToken,
    payload: {
      areaId,
      areaUId,
      shouldTurnOffLights,
      shouldTurnOffAirConditioners,
      shouldCheckDoorWindowsClosed,
      shouldCloseCurtains,
      shouldNotifyBreach,
      shouldSmsBreach,
      shouldRunScenarios,
      shouldTurnOnSirens,
      sirensDuration,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function disarm(
  areaId = 0,
  areaUId = null,
  accessToken,
  shouldUnlockAfterDisArm,
  devicesToUnlockAfterDisArm
) {
  return {
    type: Pre.AREA + Actions.DISARM,
    accessToken,
    payload: {
      areaId,
      areaUId,
      shouldUnlockAfterDisArm,
      devicesToUnlockAfterDisArm,
    },
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}

export function resetLocalArmReport(areaId) {
  var payload = {
    areaId: 0,
    areaUId: null,
  };
  if (typeof areaId == "string") payload.areaUId = areaId;
  if (typeof areaId == "number") payload.areaId = areaId;

  return {
    type: Pre.AREA + Actions.ARM_REPORT_RESET,
    payload,
    socket: {
      send: false,
      keepSocket: true,
    },
  };
}

export function AddState(model, accessToken) {
  const act = {
    type: Pre.AREA + Actions.ADD_STATE,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}

export function ActivateState(stateId, stateUId, accessToken) {
  const act = {
    type: Pre.AREA + Actions.ACTIVE_STATE,
    payload: { stateId, stateUId },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}

export function DeActivateState(stateId, stateUId, accessToken) {
  const act = {
    type: Pre.AREA + Actions.DE_ACTIVE_STATE,
    payload: { stateId, stateUId },
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}

export function UpdateState(model, accessToken) {
  const act = {
    type: Pre.AREA + Actions.UPDATE_STATE,
    payload: model,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}

export function RemoveState(stateId, stateUId, areaId, areaUId, accessToken) {
  var payload = {
    id: stateId || 0,
    uId: stateUId || null,
    areaId: areaId || 0,
    areaUId: areaUId || null,
  };
  // if (typeof areaId == "string") payload.areaUId = areaUId;
  // if (typeof areaId == "number") payload.areaId = areaId;
  // if (typeof stateUId == "string") payload.uId = stateUId;
  // if (typeof stateId == "number") payload.id = stateId;
  // console.log(payload);
  const act = {
    type: Pre.AREA + Actions.REMOVE_STATE,
    payload,
    socket: { send: true, keepSocket: true },
    accessToken,
  };
  return act;
}

export function AreaCache(areas) {
  const act = {
    type: Pre.AREA + Actions.ALL_CACHE,
    payload: areas,
    socket: { send: false, keepSocket: true },
  };
  return act;
}
// === Touch Panel ===
export function clearTouchPanelAlert() {
  return {
    type: Pre.AREA + Actions.ASK_PIN_CLEAR,
    socket: { send: false, keepSocket: true },
  };
}



export function openAllAccessControlDoors(
  areaId = 0,
  areaUId = null,
  accessToken = "",
  excludeHiddenDevices = DEFAULT_EXCLUDE_HIDDEN_DEVICES
) {
  var payload = {
    areaId,
    areaUId,
    excludeHiddenDevices,
  };
  return {
    type: Pre.AREA + Actions.OPEN_ALL_ACCESS_CONTROL_DOORS,
    accessToken,
    payload,
    socket: {
      send: true,
      keepSocket: true,
    },
  };
}